/** The activity record's names: what the app shows as its title, the internal name beside
 *  it, and the type's one word. Shared by the header and the fact band. */
import { ACTIVITY_TYPE_LABELS, type ActivityRow } from '@/api/activities';

/** What the app shows as the activity's name (never empty: `Activity #<id>`). */
export function activityTitle(a: Pick<ActivityRow, 'id' | 'name' | 'display_name'>): string {
  return a.display_name?.trim() || a.name?.trim() || `Activity #${a.id}`;
}

/** The internal name, when the app shows another one. */
export function internalName(a: Pick<ActivityRow, 'name' | 'display_name'>): string | null {
  const name = a.name?.trim();
  const shown = a.display_name?.trim();
  return name && shown && name !== shown ? name : null;
}

/** The type's one word ("Attraction", never "Attractions"). */
export function activityTypeLabel(a: Pick<ActivityRow, 'type' | 'type_display'>): string {
  return ACTIVITY_TYPE_LABELS[a.type] ?? a.type_display ?? `Type ${a.type}`;
}
